<main class="access-error" role="main" aria-labelledby="accessDeniedHeading">
  <section class="card" aria-live="polite">
    <h1 id="accessDeniedHeading" class="title">Access Denied</h1>

    <p class="message">
      Please reach out to
      <a class="email" href="mailto:pvtaccess&#64;exxonmobil.com"> pvtaccess&#64;exxonmobil.com</a>
      for getting access to this application.
    </p>

    <p class="cta">
      <a class="link" (click)="OnLoginAgain()" (keyup.enter)="OnLoginAgain()" tabindex="0" role="button"> Please click here to login again </a>
    </p>
  </section>
</main>